var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturedIconLgWarningDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#7C320B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 16.9963V20.9963M19.9998 24.9963H20.0098M18.6151 11.888L10.3902 26.0947C9.93398 26.8827 9.70588 27.2767 9.73959 27.6C9.769 27.8821 9.91677 28.1384 10.1461 28.3051C10.4091 28.4963 10.8643 28.4963 11.7749 28.4963H28.2246C29.1352 28.4963 29.5904 28.4963 29.8534 28.3051C30.0827 28.1384 30.2305 27.8821 30.2599 27.6C30.2936 27.2767 30.0655 26.8827 29.6093 26.0947L21.3844 11.888C20.9299 11.1029 20.7026 10.7103 20.4061 10.5784C20.1474 10.4634 19.8521 10.4634 19.5935 10.5784C19.2969 10.7103 19.0696 11.1029 18.6151 11.888Z",
    stroke: "#FFD346",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedIconLgWarningDark);
export default __webpack_public_path__ + "static/media/featured_icon_lg_warning_Dark.59f26998f1ff793e743e4f21e2d2c3fd.svg";
export { ForwardRef as ReactComponent };